'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import TwoCardWallOfReviews from './TwoCardWallOfReviews';
import { ReviewCard } from './ReviewCard';

export default function WallOfReviews({ block, position }) {
  const entry = block?.wall_of_reviews?.reference?.[0] ?? {};
  const { uid, color_theme, heading, review_card, variant_format } = entry;
  const reviewCards = review_card ?? [];
  const normalizedColorTheme = color_theme?.toLowerCase().trim();
  const theme =
    sectionThemes[normalizedColorTheme] ?? sectionThemes['warm pewter 30%'];

  const paginationThemeClass =
    normalizedColorTheme === 'parlor green'
      ? 'swiper-bullet-parlor-green'
      : normalizedColorTheme === 'warm pewter 80%'
        ? 'swiper-bullet-warm-pewter'
        : 'swiper-bullet-green';
  const paginationClasses = `review-pagination swiper-bullet ${paginationThemeClass} mt-10 flex justify-center`;

  if (variant_format?.toLowerCase().includes('2')) {
    return <TwoCardWallOfReviews entry={entry} position={position} />;
  }

  return (
    <section
      id={`${uid}_${position}`}
      data-name="wall-of-reviews"
      className={`flex w-full flex-col items-center justify-center py-20 sm:py-30 lg:pt-20 lg:pb-30 ${theme.section}`}
    >
      <div
        className={`mx-auto flex w-full max-w-90 flex-col items-center justify-center gap-10 px-5 sm:max-w-3xl sm:gap-15 sm:px-10 lg:max-w-360 lg:gap-15 lg:px-10`}
      >
        <div className="flex w-full max-w-301 flex-col items-start gap-10">
          {heading && (
            <div className="flex w-full flex-col items-start gap-15">
              <h2
                className={`h3 lg:h2 mx-auto w-55 text-center sm:w-full ${theme.heading}`}
              >
                {heading}
              </h2>
            </div>
          )}

          {reviewCards.length > 0 && (
            <>
              <div className="relative left-1/2 w-screen -translate-x-1/2 sm:hidden">
                <Swiper
                  modules={[Pagination]}
                  slidesPerView="auto"
                  centeredSlides
                  centerInsufficientSlides
                  loop={reviewCards.length > 1}
                  spaceBetween={24}
                  pagination={{ el: '.review-pagination', clickable: true }}
                  className="w-full [&_.swiper-wrapper]:items-stretch!"
                >
                  {reviewCards.map((card, index) => (
                    <SwiperSlide
                      key={card._metadata?.uid ?? index}
                      className="flex! h-auto! w-70! items-center! justify-center!"
                    >
                      <ReviewCard
                        card={card}
                        cardClass={theme.card}
                        itemClass="mx-auto w-70"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
                <div className={paginationClasses} />
              </div>

              <div className="hidden w-full gap-5 sm:block sm:columns-2 sm:gap-5 lg:columns-3">
                {reviewCards.map((card, index) => (
                  <div
                    key={card._metadata?.uid ?? index}
                    className="mb-6 break-inside-avoid"
                  >
                    <ReviewCard card={card} cardClass={theme.card} />
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}

// section color_theme -> matching card background
export const sectionThemes = {
  'warm pewter 30%': {
    section: 'bg-warm-pewter-30',
    card: 'bg-warm-pewter-60',
    heading: 'text-parlor-green'
  },
  'warm pewter 80%': {
    section: 'bg-warm-pewter-80',
    card: 'bg-warm-pewter-20',
    heading: 'text-parlor-green'
  },
  'parlor green': {
    section: 'bg-parlor-green',
    card: 'bg-parlor-green-10',
    heading: 'text-crisp-white'
  }
};
